var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarPicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-leave-1262677",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.407,
    height: 19.433,
    viewBox: "0 0 19.407 19.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32299",
    "data-name": "Path 32299",
    d: "M222.225,64.927V62.114a.511.511,0,0,0-1.023,0v2.813a.511.511,0,1,0,1.023,0Z",
    transform: "translate(-217.111 -61.603)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32300",
    "data-name": "Path 32300",
    d: "M445.712,61.6a.513.513,0,0,0-.511.511v2.813a.511.511,0,0,0,1.023,0V62.113a.513.513,0,0,0-.512-.511Z",
    transform: "translate(-430.882 -61.602)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32301",
    "data-name": "Path 32301",
    d: "M298.6,202.366a.753.753,0,0,0-.767-.767h-3.068a.754.754,0,0,0-.767.767v3.068a.754.754,0,0,0,.767.767h3.068a.753.753,0,0,0,.767-.767Zm-1.023,2.813h-2.557v-2.557h2.557Z",
    transform: "translate(-286.584 -195.207)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32302",
    "data-name": "Path 32302",
    d: "M416.2,202.366a.753.753,0,0,0-.767-.767h-3.068a.754.754,0,0,0-.767.767v3.068a.753.753,0,0,0,.767.767h3.068a.753.753,0,0,0,.767-.767Zm-1.023,2.813h-2.557v-2.557h2.557Z",
    transform: "translate(-398.814 -195.207)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32303",
    "data-name": "Path 32303",
    d: "M180.235,319.2h-3.068a.754.754,0,0,0-.767.767v3.068a.753.753,0,0,0,.767.767h3.068a.753.753,0,0,0,.767-.767v-3.068A.753.753,0,0,0,180.235,319.2Zm-.256,3.58h-2.557v-2.557h2.557Z",
    transform: "translate(-174.354 -307.438)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32304",
    "data-name": "Path 32304",
    d: "M297.835,319.2h-3.068a.754.754,0,0,0-.767.767v3.068a.753.753,0,0,0,.767.767h3.068a.753.753,0,0,0,.767-.767v-3.068A.754.754,0,0,0,297.835,319.2Zm-.256,3.58h-2.557v-2.557h2.557Z",
    transform: "translate(-286.585 -307.438)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32305",
    "data-name": "Path 32305",
    d: "M412.366,323.8h3.068a.754.754,0,0,0,.767-.767v-3.068a.753.753,0,0,0-.767-.767h-3.068a.754.754,0,0,0-.767.767v3.068A.754.754,0,0,0,412.366,323.8Zm.256-3.58h2.557v2.557h-2.557Z",
    transform: "translate(-398.814 -307.437)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32306",
    "data-name": "Path 32306",
    d: "M181,201.854a.242.242,0,0,0-.256-.256h-4.091a.242.242,0,0,0-.256.256v4.091a.242.242,0,0,0,.256.256h4.091a.242.242,0,0,0,.256-.256Zm-2.3,3.58a.256.256,0,1,1,.256-.256A.242.242,0,0,1,178.7,205.434Zm.256-1.278a.256.256,0,1,1-.512,0v-1.278a.256.256,0,0,1,.512,0Z",
    transform: "translate(-174.353 -195.206)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32307",
    "data-name": "Path 32307",
    d: "M257.9,95.712a.513.513,0,0,0-.511-.511h-7.671a.511.511,0,1,0,0,1.023h7.671a.513.513,0,0,0,.512-.511Z",
    transform: "translate(-243.832 -93.667)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32308",
    "data-name": "Path 32308",
    d: "M133.979,113.1H148.63a2.39,2.39,0,0,0,2.378-2.378V97.578A2.39,2.39,0,0,0,148.63,95.2h-.921a.511.511,0,1,0,0,1.023h.946a1.364,1.364,0,0,1,1.355,1.355V110.7a1.364,1.364,0,0,1-1.355,1.355H133.979a1.364,1.364,0,0,1-1.355-1.355V97.578a1.364,1.364,0,0,1,1.355-1.355h.946a.511.511,0,1,0,0-1.023h-.946a2.39,2.39,0,0,0-2.378,2.378V110.7a2.4,2.4,0,0,0,2.378,2.4Z",
    transform: "translate(-131.601 -93.666)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPicker);
export default __webpack_public_path__ + "static/media/calendar-picker.e6078be6d365a25c41505b669bd55d36.svg";
export { ForwardRef as ReactComponent };